import { ref, type Ref } from 'vue';

export const sharedOpenId: Ref<symbol | null> = ref(null);
export const sharedPinnedId: Ref<symbol | null> = ref(null);

let _closeHandler: (() => void) | null = null;

export function registerAppsDropdownClose(handler: (() => void) | null): void {
  _closeHandler = handler;
}

export function closeAppsDropdown(): void {
  _closeHandler?.();
}

export function resetAppsDropdownState(): void {
  sharedOpenId.value = null;
  sharedPinnedId.value = null;
}
